import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
export const styles = {
  wrap: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    $$css: true
  },
  trigger: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kmVPX3: "x1717udv",
    keTefX: "x1sjeuen",
    kEafiO: "x178xt8z",
    kWqL5O: "xs1s249",
    kt9PQ7: "xso031l",
    kZ1KPB: "xe0pwq",
    kPef9Z: "x13fuv20",
    kSWEuD: "x32b0ac",
    kfdmCh: "x1q0q8m5",
    k4WBpm: "x19ypqd9",
    kLZC3w: "x1p7xzfl",
    k26BEO: "x19mpx84",
    kL6WhQ: "xra1o3",
    kaZRDh: "x1gn9uwl",
    kaIpWk: "xoy5co8",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1k6wstc",
    k63SB2: "xomqrzn",
    kLWn49: "xo5v014",
    kkrTdU: "x1ypdohk",
    kDPRdz: "x1tqbdv0",
    kGatDN: "x2oj8u",
    k3Woio: "xs6sfba",
    kiEn40: "x13iak60",
    $$css: true
  },
  bubble: {
    kVAEAm: "x10l6tqk",
    kY2c9j: "x1aciyhk",
    krVfgx: "x36attc",
    kLqNvP: "x1o0tod",
    kzqmXN: "xezivpi",
    ks0D6T: "x1jkqq1h",
    kLKAdn: "x1bkoilk",
    kGO01o: "xngcwlf",
    kZCmMZ: "x1115b6m",
    kwRFfy: "xbabsup",
    kaIpWk: "xxltkoq",
    kWkggS: "xvys5x3",
    kEafiO: "x178xt8z",
    kWqL5O: "xs1s249",
    kt9PQ7: "xso031l",
    kZ1KPB: "xe0pwq",
    kPef9Z: "x13fuv20",
    kSWEuD: "x32b0ac",
    kfdmCh: "x1q0q8m5",
    k4WBpm: "x19ypqd9",
    kLZC3w: "x1p7xzfl",
    k26BEO: "x19mpx84",
    kL6WhQ: "xra1o3",
    kaZRDh: "x1gn9uwl",
    kGVxlE: "x16cx2vi",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "x1fm9vgf",
    kLWn49: "xfrs9s4",
    k9WMMc: "x1yc453h",
    khDVqt: "xeaf4i8",
    $$css: true
  },
  bubbleEnd: {
    kLqNvP: "xhi6v0a",
    kt4wiu: "xtijo5x",
    $$css: true
  }
};